import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=2e04eec8&"
import script from "../../../services/applicant/home/terms-of-service.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/home/terms-of-service.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports